export function filtersConvertFromApi(spy: any){ 
    const bedrooms = []
    if (spy.bedrooms === '' || spy.bedrooms.length === 0){
        bedrooms.push('Any')
    } else if (spy.bedrooms.length === 1){
        bedrooms.push(spy.bedrooms[0].toString())
    } else if (spy.bedrooms.length > 1){
        bedrooms.push(`${spy.bedrooms[0]}+`)
    } else {
        bedrooms.push('1+')
    }

    const beds = []
    if (spy.beds === '' || spy.beds.length === 0){
        beds.push('Any')
    } else if (spy.beds.length === 1){
        beds.push(spy.beds[0].toString())
    } else if (spy.beds.length > 1){
        beds.push(`${spy.beds[0]}+`)
    } else {
        beds.push('1+')
    }  

    const pets = []
    if (spy.pets === 0){
        pets.push(`0`)
    } else {
        pets.push(`${spy.pets}+`)
    }

    return {
            bedrooms: bedrooms,
            beds: beds,
            pets: pets
    }    
}